<div class="cardsWrapper">
    <app-popup-card-base-layout
        cdkOverlayOrigin
        #trigger="cdkOverlayOrigin"
        (click)="isExpanded = true"
        (keydown)="onKeyDown($event)"
        tabindex="0"
        aria-label="Show card details"
        [shadow]="'soft'"
        [highlightColor]="data?.eventType === dueDatetype ? 'blue' : 'yellow'"
    >
        @if (size === 'minimal') {
            <div class="minimalSize">
                @if (data?.eventDate) {
                    <span class="dateInfo">{{ $safeNavigationMigration(data?.eventDate) | date: 'h:mm a' }} - </span>
                }
                @if (data?.contactInfo) {
                    <span class="title">{{ data?.contactInfo }} - </span>
                }
                <span class="title">{{ data?.name }}</span>
            </div>
        }
        @if (size === 'normal') {
            <div class="normalSize">
                <lib-badge
                    [text]="data?.eventType === dueDatetype ? 'Due Date' : 'Follow up'"
                    [color]="data?.eventType === dueDatetype ? 'secondary' : 'tertiary'"
                >
                </lib-badge>
                <div class="title">{{ data?.name }}</div>
                @if (data?.opportunityUsers?.length && data?.eventType === dueDatetype) {
                    <app-user-info [users]="$any($safeNavigationMigration(data?.opportunityUsers))"> </app-user-info>
                }
                @if (data?.contactInfo) {
                    <div class="subtitle">{{ data?.contactInfo }}</div>
                }
            </div>
        }
    </app-popup-card-base-layout>
</div>

<ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isExpanded"
    [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
    (detach)="isExpanded = false"
    [cdkConnectedOverlayHasBackdrop]="true"
    [cdkConnectedOverlayBackdropClass]="'cdk-overlay-custom-backdrop'"
    (backdropClick)="isExpanded = false"
    [cdkConnectedOverlayFlexibleDimensions]="false"
    [cdkConnectedOverlayPush]="true"
    [cdkConnectedOverlayPositions]="[
        {
            originX: 'center',
            originY: 'center',
            overlayX: 'center',
            overlayY: 'center'
        }
    ]"
>
    <app-opportunity-card-expanded
        cdkTrapFocus
        cdkTrapFocusAutoCapture="true"
        [data]="data"
        (closeClicked)="this.isExpanded = false"
        (goToClicked)="onGoToClicked($safeNavigationMigration(data?.id))"
    >
    </app-opportunity-card-expanded>
</ng-template>
